import type { AhrefLink, GeofencedAhrefLink } from './storyblok/types/global.types';

export function isGeofencedAhrefLink(
  link: AhrefLink | GeofencedAhrefLink,
): link is GeofencedAhrefLink {
  return (link as GeofencedAhrefLink).countries !== undefined;
}
